import styled from '@emotion/styled';
import { CommonBG, CommonText } from 'ui/theme/Color';

export const StatusBadge = styled.div`
  display: flex;
  gap: 10px;
  span,
  button {
    display: flex;
    gap: 4px;
    align-items: center;
    &:before {
      content: '';
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
  }
`;

export const StatusItem = styled.button<{ background?: string; opacity?: string }>`
  &:before {
    background: ${({ background }) => background || CommonBG.Primary};
    opacity: ${({ opacity }) => opacity || '1'};
  }
`;

export const IsActive = styled.span<{ background?: string }>`
  &:before {
    background: ${({ background }) => background || CommonBG.Primary};
  }
`;
export const IsDelay = styled.span<{ background?: string }>`
  &:before {
    background: ${({ background }) => background || CommonText.Error};
  }
`;
export const IsComplet = styled.span<{ background?: string }>`
  &:before {
    background: ${({ background }) => background || CommonText.Light};
    opacity: 0.7;
  }
`;
export const IsNotCompleted = styled.span<{ background?: string }>`
  &:before {
    background: ${({ background }) => background || CommonText.Error};
  }
`;
export const IsReady = styled.span<{ background?: string }>`
  &:before {
    background: ${({ background }) => background || CommonText.Light};
  }
`;
export const IsIssue = styled.span<{ background?: string }>`
  &:before {
    background: ${({ background }) => background || CommonText.WarningMinor};
  }
`;
